module.exports = __webpack_public_path__ + "static/media/close.062321c3.svg";